module.exports = __webpack_public_path__ + "static/media/footer_twitter.9bf73952.svg";